import React from 'react';

const CalenderIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.6667 4H3.33333C2.59695 4 2 4.59695 2 5.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V5.33333C14 4.59695 13.403 4 12.6667 4Z'
        stroke='#A1A1A1'
        strokeWidth='1.33333'
      />
      <path
        d='M2 6.66667C2 5.40933 2 4.78133 2.39067 4.39067C2.78133 4 3.40933 4 4.66667 4H11.3333C12.5907 4 13.2187 4 13.6093 4.39067C14 4.78133 14 5.40933 14 6.66667H2Z'
        fill='#A1A1A1'
      />
      <path
        d='M4.66406 2V4M11.3307 2V4'
        stroke='#A1A1A1'
        strokeWidth='1.33333'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default CalenderIcon;
